module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/d1097d652dfc1172d285bcee559acac0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_highest.svg
// module id = p5XJ
// module chunks = 0